module.exports = __webpack_public_path__ + "static/img/store-example.4e9bd04f.png";